import { Spinner } from "@maxhub/max-ui";
import styles from "./Loader.module.css";

export const Loader = () => {
  return (
    <div className={styles.overlay}>
      <Spinner className={styles.spinner} size={30} />
    </div>
  );
};
